/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet-async';
import { Button } from '../../shared/ui';
import Modal from '../../components/modal/Modal';
import '../b2bPage/b2bPage.css';
import gammaThemeStyles from '../b2bPage/b2bGammaTheme.module.css';
import landingStyles from '../b2bPage/B2bLanding.module.css';
import InstallAppQrTile, { getInstallAppPlatformMeta } from './InstallAppQrTile';
import './installAppPage.css';

const B2B_GAMMA_FONTS =
  'https://fonts.googleapis.com/css2?family=Fira+Sans:wght@400;500;600&family=Inconsolata:wght@700&display=swap';

export default function InstallAppPage() {
  const { t } = useTranslation();
  const [qrPopup, setQrPopup] = useState(null);
  const APK_PATH = '/download/km220.apk';
  const APP_STORE_URL = 'https://apps.apple.com/ua/app/220-km-com/id6760019365';
  const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.km220';
  const androidQrUrl = useMemo(
    () => `${window.location.origin}${APK_PATH}`,
    [APK_PATH]
  );
  const VIDEO_INSTRUCTION_OTHER = 'https://photos.google.com/share/AF1QipP7oSFOaSIELSrtsbQwUEZoeDYxsjJmHeRpkU_AmNBxkYRlrAJ45OiIHIGmzBIHvA?key=QWF0a3lkYVk4T29TN0VzRXNaRDVBSVplSUNOWTl3';

  const downloadApk = () => {
    const link = document.createElement('a');
    link.href = APK_PATH;
    link.download = 'km220.apk';
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  useEffect(() => {
    document.body.classList.add('b2b-route');
    const layout = document.getElementById('layout');
    layout?.classList.add('b2b-route-layout', 'install-app-route-layout');
    return () => {
      document.body.classList.remove('b2b-route');
      layout?.classList.remove('b2b-route-layout', 'install-app-route-layout');
    };
  }, []);

  const handleInstallClick = () => {
    ReactGA.event({
      category: 'installApp',
      action: 'install app button clicked',
    });

    const isAndroid = /Android/.test(navigator.userAgent);
    const isIphone = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isAndroid) {
      window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
      return;
    }

    const url = isIphone ? APP_STORE_URL : VIDEO_INSTRUCTION_OTHER;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleQrPopupInstall = () => {
    if (!qrPopup) return;

    ReactGA.event({
      category: 'installApp',
      action: `install app qr popup ${qrPopup.platform}`,
    });

    if (qrPopup.platform === 'android') {
      downloadApk();
    } else if (qrPopup.platform === 'play') {
      window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
    } else {
      window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
    }

    setQrPopup(null);
  };

  const popupPlatformMeta = qrPopup ? getInstallAppPlatformMeta(qrPopup.platform) : null;
  const PopupPlatformIcon = popupPlatformMeta?.Icon;

  return (
    <div className={`${gammaThemeStyles.b2bPageRoot} installAppPageRoot`}>
      <Helmet>
        <link rel="stylesheet" href={B2B_GAMMA_FONTS} />
      </Helmet>
      <div id="installAppPage" className="installAppPageContainer">
        <div className="installAppPageContent">
          <div className="installAppIntro">
            <p className="installAppAttention">{t('installAppAttention')}</p>
            <p className="installAppText installAppTextNote">{t('installAppTextThird')}</p>
          </div>
          <div className={`${landingStyles.wideButtonRow} installAppButtonRow`}>
            <Button
              onClick={handleInstallClick}
              style={{
                borderRadius: '20px',
                minHeight: '56px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
              }}
            >
              <span className="installAppButtonText">{t('installAppButton')}</span>
            </Button>
          </div>

          <div className="installAppQrGrid" aria-label={t('installAppQrSectionLabel')}>
            <InstallAppQrTile
              platform="ios"
              url={APP_STORE_URL}
              title={t('installAppQrIosTitle')}
              subtitle={t('installAppQrIosSubtitle')}
              qrAlt={t('installAppQrIosAlt')}
              onQrClick={setQrPopup}
            />
            <InstallAppQrTile
              platform="play"
              url={PLAY_STORE_URL}
              title={t('installAppQrPlayTitle')}
              subtitle={t('installAppQrPlaySubtitle')}
              qrAlt={t('installAppQrPlayAlt')}
              onQrClick={setQrPopup}
            />
            <InstallAppQrTile
              platform="android"
              url={androidQrUrl}
              title={t('installAppQrAndroidTitle')}
              subtitle={t('installAppQrAndroidSubtitle')}
              qrAlt={t('installAppQrAndroidAlt')}
              onQrClick={setQrPopup}
            />
          </div>
        </div>
      </div>

      <Modal modalOpen={Boolean(qrPopup)} setModalOpen={open => !open && setQrPopup(null)}>
        {qrPopup ? (
          <div className="installAppQrPopup" role="dialog" aria-modal="true" aria-labelledby="install-app-qr-popup-title">
            <div className="installAppQrPopupPlatformRow">
              {PopupPlatformIcon ? (
                <PopupPlatformIcon
                  className={`installAppQrPlatformIcon ${popupPlatformMeta.iconClassName}`}
                  aria-hidden
                />
              ) : null}
              <div className="installAppQrPopupPlatformText">
                <p id="install-app-qr-popup-title" className="installAppQrPopupTitle">
                  {qrPopup.title}
                </p>
                <p className="installAppQrPopupSubtitle">{qrPopup.subtitle}</p>
              </div>
            </div>
            <a
              href={qrPopup.url}
              className="installAppQrPopupLink"
              target={qrPopup.platform === 'android' ? undefined : '_blank'}
              rel="noopener noreferrer"
              download={qrPopup.platform === 'android' ? 'km220.apk' : undefined}
              aria-label={qrPopup.qrAlt}
              onClick={event => {
                if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                  return;
                }
                event.preventDefault();
                handleQrPopupInstall();
              }}
            >
              <div className="installAppQrPopupFrame">
                <img src={qrPopup.qrDataUrl} alt="" className="installAppQrPopupImage" />
              </div>
            </a>
            <Button
              onClick={handleQrPopupInstall}
              style={{
                borderRadius: '20px',
                minHeight: '56px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '20px auto 0',
              }}
            >
              <span className="installAppButtonText">{t('installAppButton')}</span>
            </Button>
          </div>
        ) : null}
      </Modal>
    </div>
  );
}
